export default {
    createcourse:{},
    courseList: [],
    TopicByID : []
}